export const Apis = {
  palm_actions: {
      list_palm               : "palm/liste",
      fiche_palm              : "palm/fiche",
      scan_qrcode_palm        : "palm/scan_qrcode_palm",
      generate_qr             : "palm/generate-qr",
      ajouter_palm            : "palm/ajouter",
      modifier_palm           : "palm/modifier",
      modifier_palm_cords     : "palm/modifier-cords",
      modifier_position_palm  : "palm/modifier-position",
      tab_zones               : "palm/zones/liste",
      alimenter               : "palm/alimenter",
      alimentation_historique : "palm/alimentation/historique",
      arroser                 : "palm/arroser",
      arrosage_historique     : "palm/arrosage/historique",
      ajouter_anomalie        : "palm/anomalie/ajouter",
      liste_anomalies         : "palm/anomalie/liste",
      solve_anomalie          : "palm/anomalie/solve",
      ajouter_produit         : "palm/produit/ajouter",
      produit_historique      : "palm/produit/historique",
      log_liste               : "palm/logs",
  },
  dashboard: {
    dashboard_stats            : "backoffice/dashboard",
  },
  tasks: {
      ajouter_task            : "palm/tasks/ajouter",
      listTasks               : "palm/tasks/liste",
      executeTask             : "palm/tasks/execute",
  },
  observations: {
    listObservations          : "observation/historique",
    addNote                   : "observation/add-note",
  },
  travaux: {
    listTravaux               : "palm/travaux/historique",
    addTravaux                : "palm/travaux/ajouter",
  },
  upload: {
      base                    : "upload/backoffice",
      convertMergePdf         : "upload/backoffice/convert-merge/pdf"
  },
  codification: {
      tab_codification        : "codification/liste",
      add_codif               : "codification/ajouter",
      edit_codif              : "codification/modifier",
      delete_codif            : "codification/delete",
  },
  parametrage: {  
    tab_parametrage           : "parametrage/liste",
    add_codif                 : "parametrage/ajouter",
    edit_codif                : "parametrage/modifier",
    activate_codif            : "parametrage/activate",
    delete_codif              : "parametrage/delete",
    liste_fichier_param       : "parametrage/fichier/liste",
    add_fichier_param         : "parametrage/fichier/ajouter",
    update_fichier_param      : "parametrage/fichier/modifier",
    activate_fichier_param    : "parametrage/fichier/activate",
    delete_fichier_param      : "parametrage/fichier/delete",
    liste_fichier_param_paginated  : "parametrage/fichier/liste-paginated",
    global_fichier_param           : "parametrage/fichier/global",
    tab_parametrage_paginated      : "parametrage/liste-paginated",
    get_autre                      : "parametrage/autre/get",
    toggle_autre                   : "parametrage/autre/toggle",
  },
  authentication: {
      connexion               : "backoffice/login",
      deconnexion             : "backoffice/logout",
  },
  utilisateurs: {
      base                    : "backoffice/utilisateurs",
      // liste                : "backoffice/utilisateurs",
      // fiche                : "backoffice/utilisateurs",
      // ajouter              : "backoffice/utilisateurs/ajouter",
      // modifier             : "backoffice/utilisateurs/modifier",
      // supprimer            : "backoffice/utilisateurs/supprimer",
  },
  adherents: {
    base                      : "backoffice/adherents",
    adherendinfo              : "backoffice/profile/adherent/info/adherent/info-m",
    sendContactOTP            : "backoffice/adherents/update/send-contact-otp",
    verifyContactOTP          : "backoffice/adherents/update/verify-contact-otp",
    checkPendingOtp           : "backoffice/adherents/update/check-pending-otp"
  },
  partenaires: {
    base                      : "backoffice/partenaires",
    profile                   : "backoffice/profile/partenaire/info-m"
  },
  demandes: {
    base                      : "backoffice/demandes"
  },
  adhesion: {
    base                      : "backoffice/adhesion"
  },
  fds: {
    base                      : "backoffice/fds"
  },
  dhc: {
    base                      : "backoffice/dhc"
  },
  beneficiare_oracle: {
    base                      : "backoffice/benificiare"
  },
  ald: {
    base                      : "backoffice/ald"
  },
  pec: {
    base                      : "backoffice/pec"
  },
  ep: {
    base                      : "backoffice/ep"
  },
  reclamations: {
    base                      : "backoffice/reclamations"
  },
  statistiques: {
    base                      : "backoffice/statistiques"
  }
};
